import {useRootStore} from "store/useRootStore"
import {observer} from "mobx-react"
import {GridTableColumn, GridTableHeaderWrapper} from "pages/admin/common/common-style-component"
import Tree from "rc-tree"
import {MouseEventHandler} from "react"
import {useFindAllCategories} from "hooks/queries/category.query"
import {Category} from "dto/category/category"

type CategoryTreeData = {
    title: string
    key: number
    children?: CategoryTreeData[]
    parentId?: number
}

// type CategoryMap = {
//     [key: number]: number
//     category: Category
// }
export const CategoryView = observer(() => {
        const categories = useFindAllCategories()?.data
        const categoryTreeMap = new Map<number, CategoryTreeData>()
        const categoryMap = new Map<number, Category>()
        categories?.filter((category: Category) => (category.level === "CITY")).forEach((category: Category) => {
            if (category && category.id) {
                categoryTreeMap.set(category.id, {
                    title: category.name,
                    key: category.id,
                    children: [],
                    parentId: category.parentId
                })
                category.children = []
                categoryMap.set(category.id, category)
            }
        })
        categories?.filter((category: Category) => (category.level === "DISTRICT")).forEach((category: Category) => {
            if (category && category.id ) {
                categoryMap.set(category.id, category)
                if(category.parentId) {
                    const parent = categoryMap.get(category.parentId)
                    if (parent) {
                        parent.children = parent?.children ? [...parent.children || [] , category] : []
                    }
                }

                if(category.parentId) {
                    const parent = categoryTreeMap.get(category.parentId)
                    if (parent) {
                        if (!parent.children) parent.children = []
                        parent.children = [...parent.children, {
                            title: category.name,
                            key: category.id,
                            children: [],
                        }]
                    }
                }

            }
        })

        // const categoryTreeMap = categories ? categories.reduce((acc: CategoryMap, cur: Category) => {
        //     if (!cur || !cur?.id) return
        //     acc[cur.id] = cur.id
        //
        // }, {} as CategoryMap) : {}
        console.log("category map : ", categoryTreeMap)
        const categoryTreedata = [{
            title: '전체',
            key: 0,
            children: Array.from(categoryTreeMap.values())
        }]
        const {
            adminStore: {
                realDeviceStore: {
                    selectCategory
                }
            }
        } = useRootStore()
        return (
            <>
                <GridTableHeaderWrapper gridTemplateColumns="100%" className="mt10">
                    <GridTableColumn>카테고리</GridTableColumn>
                </GridTableHeaderWrapper>
                <div className="p-2">
                    <Tree
                        className="myCls"
                        showLine
                        selectable={true}
                        defaultExpandAll
                        // onExpand={this.onExpand}
                        // defaultSelectedKeys={this.state.defaultSelectedKeys}
                        // defaultCheckedKeys={this.state.defaultCheckedKeys}
                        // onSelect={this.onSelect}
                        // onCheck={this.onCheck}
                        onSelect={(selectedKeys, info) => {
                            const key = selectedKeys[0] as number || 0
                            const category = categoryMap.get(key)
                            selectCategory(category)
                            console.log("selected category : ", category)
                        }}
                        treeData={categoryTreedata}
                    />
                </div>
            </>
        )
    }
)

const treeData = [
    {
        key: '0-0',
        title: 'parent 1',
        children: [
            {key: '0-0-0', title: 'parent 1-1', children: [{key: '0-0-0-0', title: 'parent 1-1-0'}]},
            {
                key: '0-0-1',
                title: 'parent 1-2',
                children: [
                    {key: '0-0-1-0', title: 'parent 1-2-0', disableCheckbox: true},
                    {key: '0-0-1-1', title: 'parent 1-2-1'},
                    {key: '0-0-1-2', title: 'parent 1-2-2'},
                    {key: '0-0-1-3', title: 'parent 1-2-3'},
                    {key: '0-0-1-4', title: 'parent 1-2-4'},
                    {key: '0-0-1-5', title: 'parent 1-2-5'},
                    {key: '0-0-1-6', title: 'parent 1-2-6'},
                    {key: '0-0-1-7', title: 'parent 1-2-7'},
                    {key: '0-0-1-8', title: 'parent 1-2-8'},
                    {key: '0-0-1-9', title: 'parent 1-2-9'},
                    {key: 1128, title: 1128},
                ],
            },
        ],
    },
];

export default CategoryView